import { render } from "./LeadHeader.vue?vue&type=template&id=797e4392"
import script from "./LeadHeader.vue?vue&type=script&lang=js"
export * from "./LeadHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__